// @flow

// Map URLs
export const ARCGIS_ONLINE = '//server.arcgisonline.com/ArcGIS'
export const MAP_URL_ESRI = `${ARCGIS_ONLINE}/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.jpg`
export const MAP_URL_OSM = '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
export const MAP_URL_DEFAULT = MAP_URL_ESRI

// Action types
export const prefix = '@@hfty-map/'
export const CENTER_MAP_DEFAULT = 'CENTER_MAP_DEFAULT'
export const CENTER_MAP_TO_FARM = 'CENTER_MAP_TO_FARM'
export const CENTER_MAP_TO_FIELD = 'CENTER_MAP_TO_FIELD'

// TODO: These are temporary action types for testing HEF-258
export const CHANGE_GRID_SIZE = `${prefix}CHANGE_GRID_SIZE`
export const CHANGE_GRID_ROTATION = `${prefix}CHANGE_GRID_ROTATION`
export const UPDATE_MAP = `${prefix}UPDATE_MAP`
export const SELECT_FEATURE = `${prefix}SELECT_FEATURE`
export const TOGGLE_HOVER_FEATURE = `${prefix}TOGGLE_HOVER_FEATURE`
export const CHANGE_GRID_OFFSET = `${prefix}CHANGE_GRID_OFFSET`
export const EDIT_SELECTED_FIELD = `${prefix}EDIT_SELECTED_FIELD`
export const DELETE_SELECTED_FIELD = `${prefix}DELETE_SELECTED_FIELD`
export const TOGGLE_HOVER_POINT = `${prefix}TOGGLE_HOVER_POINT`
export const CHANGE_BASE_LAYER = `${prefix}CHANGE_BASE_LAYER`
export const SELECT_JOB = `${prefix}SELECT_JOB`
export const TOGGLE_PANEL = `${prefix}TOGGLE_PANEL`
export const SELECT_JOB_FEATURE = `${prefix}SELECT_JOB_FEATURE`
export const SELECT_SOIL_TEST_FILTER = `${prefix}SELECT_SOIL_TEST_FILTER`
export const TOGGLE_IMAGERY_LAYERS = `${prefix}TOGGLE_IMAGERY_LAYERS`
export const SHOW_PREVIOUS_POINTS = `${prefix}SHOW_PREVIOUS_POINTS`
export const SET_USER_STATE_BBOX = `${prefix}SET_USER_STATE_BBOX`

export const LAYER_CATEGORY_HEFTY = 'Hefty'
export const LAYER_TYPE_COMPOSITION = 'composition'
export const SRC_TYPE_PNGBLOB = 'PngBlob'

export const BALTIC_SD_LATLON = [[43.76, -96.7401], [43.75, -96.7402]]
